(() => {
  if (window.sapContentPages) return;
  window.sapContentPages = true;
  let landingTimer;
  const alignPart = target => {
    const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    window.scrollTo({top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'instant'});
  };
  for (const type of ['wheel', 'touchstart', 'keydown', 'pointerdown']) window.addEventListener(type, () => clearTimeout(landingTimer), {passive: true});
  // S171: the policy tab strip (owlet alternate page) scrolls; bring the current tab into view on load and fade the edges that hide more tabs.
  const strips = () => document.querySelectorAll('.sap-ct-fp2-tabs ul').forEach(row => {
    if (row.dataset.stripReady) return;
    row.dataset.stripReady = 'true';
    const cue = () => { row.toggleAttribute('data-scroll-start', row.scrollLeft <= 1); row.toggleAttribute('data-scroll-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 1); };
    const reveal = () => { const active = row.querySelector('[aria-current="page"]'); if (active) row.scrollLeft = Math.max(0, active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2); cue(); };
    row.addEventListener('scroll', cue, {passive: true});
    window.addEventListener('resize', reveal, {passive: true});
    document.fonts?.ready.then(reveal);
    reveal();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', strips); else strips();
  document.addEventListener('shopify:section:load', strips);
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-fp4-find]');
    if (!form) return;
    event.preventDefault();
    clearTimeout(landingTimer);
    const target = document.getElementById(form.querySelector('select').value.replace(/^#/, ''));
    if (target) {
      if (target.matches('details')) target.open = true;
      alignPart(target);
      target.setAttribute('tabindex', '-1'); target.focus({preventScroll:true});
      history.replaceState(null, '', '#' + target.id);
      landingTimer = setTimeout(() => { if (target.isConnected && location.hash === '#' + target.id) alignPart(target); }, 350);
    }
  });
  document.addEventListener('click', event => {
    const summary = event.target.closest('.sap-content-pages .sap-ct-fp2-part__sum');
    const policy = summary?.closest('.sap-content-pages[data-fp2]');
    if (policy && policy.dataset.oParts2 !== 'fold') { event.preventDefault(); return; }
    const link = event.target.closest('.sap-content-pages [data-open]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    const answer = target?.closest('details');
    if (answer) answer.open = true;
  });
  const air = () => {
    const sections = document.querySelectorAll('main .sap-content-pages > .sap-ct-s81');
    let previous = null;
    sections.forEach(section => {
      const transition = section.style.getPropertyValue('transition-property');
      const priority = section.style.getPropertyPriority('transition-property');
      section.style.setProperty('transition-property', 'none');
      section.removeAttribute('data-tight');
      const currentStyle = getComputedStyle(section);
      const skipped = !section.getClientRects().length || section.hasAttribute('data-loose');
      if (!skipped && previous) {
        const previousStyle = getComputedStyle(previous);
        if (previousStyle.backgroundColor === currentStyle.backgroundColor && parseFloat(previousStyle.paddingBottom) >= 40 && parseFloat(currentStyle.paddingTop) >= 40) section.setAttribute('data-tight', '');
      }
      section.getBoundingClientRect();
      if (transition) section.style.setProperty('transition-property', transition, priority);
      else section.style.removeProperty('transition-property');
      if (!skipped) previous = section;
    });
  };
  let airFrame;
  const revealPolicyTab = () => {
    const link = document.activeElement?.closest('.sap-content-pages .sap-ct-fp2-tabs a');
    const row = link?.closest('ul');
    if (!row) return;
    const bounds = row.getBoundingClientRect();
    const target = link.getBoundingClientRect();
    if (target.left < bounds.left) row.scrollLeft += target.left - bounds.left;
    else if (target.right > bounds.right) row.scrollLeft += target.right - bounds.right;
  };
  document.addEventListener('focusin', revealPolicyTab);
  const scheduleAir = () => { cancelAnimationFrame(airFrame); airFrame = requestAnimationFrame(() => { air(); revealPolicyTab(); }); };
  air();
  window.addEventListener('resize', scheduleAir);
  document.addEventListener('shopify:section:load', scheduleAir);
  document.addEventListener('shopify:section:unload', scheduleAir);
  document.addEventListener('shopify:section:reorder', scheduleAir);
})();
(() => {
  if (window.sapIngredientsReady) return;
  window.sapIngredientsReady = true;
  let cleanup = () => {};
  function initIngredients() {
  cleanup();
  const controller = new AbortController();
  const signal = controller.signal;
  cleanup = () => controller.abort();
  const roots = [...document.querySelectorAll('.sap-content-pages[data-br3="ingredients9"]')];
  if (!roots.length) return;
  const panels = roots.flatMap(root => [...root.querySelectorAll('[data-product-panel]')]);
  const products = panels.map(panel => panel.dataset.productPanel);
  const chips = roots.flatMap(root => [...root.querySelectorAll('[data-i9-go]')]);
  const nav = document.getElementById('product-nav');
  const browse = document.getElementById('browse');
  const navSection = nav?.closest('.shopify-section');
  const panelSections = [...new Set(panels.map(panel => panel.closest('.shopify-section')).filter(Boolean))];
  if (navSection && panelSections.length) {
    let container = navSection.closest('[data-ingredients-panels]');
    if (!container && panelSections.every(section => section.parentElement === navSection.parentElement)) {
      container = document.createElement('div');
      container.dataset.ingredientsPanels = '';
      navSection.before(container);
      container.append(navSection, ...panelSections);
    }
    if (container) navSection.classList.add('sap-ct-ingredients-nav-section');
  }
  function show(key) {
    const active = products.includes(key) ? key : null;
    roots.forEach(root => active ? root.setAttribute('data-i9-open', active) : root.removeAttribute('data-i9-open'));
    panels.forEach(panel => {
      panel.hidden = panel.dataset.productPanel !== active;
      panel.querySelector('[data-i9-prod]')?.classList.toggle('sap-ct-is-on', !panel.hidden);
    });
    if (nav) nav.hidden = !active;
    chips.forEach(chip => chip.setAttribute('aria-current', chip.dataset.i9Go === active ? 'true' : 'false'));
    return active;
  }
  function toggle(row, open) {
    const button = row.querySelector('.sap-ct-i9-row__top');
    const on = open ?? button.getAttribute('aria-expanded') !== 'true';
    row.classList.toggle('sap-ct-is-open', on);
    button.setAttribute('aria-expanded', String(on));
  }
  function go(key, ingredient) {
    const active = show(key);
    const hash = active ? '#in-' + active : '';
    if (location.hash !== hash) history.pushState(null, '', location.pathname + location.search + hash);
    let target = active ? nav : browse;
    if (active && ingredient) {
      const panel = panels.find(p => !p.hidden);
      const row = [...panel.querySelectorAll('[data-i9-ing]')].find(row => row.dataset.i9Ing === ingredient);
      if (row) { toggle(row, true); target = row; }
    }
    if (!target) return;
    target.scrollIntoView({block:'start'});
    target.setAttribute('tabindex','-1');target.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('.sap-content-pages[data-br3="ingredients9"]')) return;
    const link = event.target.closest('[data-i6-go], [data-i9-go], [data-i9-back], [data-i9-openall], .sap-ct-i9-row__top');
    if (!link) return;
    event.preventDefault();
    if (link.matches('.sap-ct-i9-row__top')) return toggle(link.closest('li'));
    if (link.hasAttribute('data-i9-openall')) {
      const rows = [...link.closest('.sap-ct-i9-all').querySelectorAll('[data-i9-ing]')];
      const open = rows.some(row => !row.classList.contains('sap-ct-is-open'));
      rows.forEach(row => toggle(row,open));link.textContent = open ? 'Close all' : 'Open all';return;
    }
    if (link.hasAttribute('data-i9-back')) return go(null);
    go(link.dataset.i9Go || link.dataset.i6Go, link.dataset.i9To);
  }, {signal});
  function resetView() { show(location.hash.startsWith('#in-') ? location.hash.slice(4) : null); }
  window.addEventListener('popstate',resetView,{signal});
  window.addEventListener('hashchange',resetView,{signal});
  const form = document.querySelector('.sap-content-pages [data-i6-search]');
  if (!form) { resetView(); return; }
  const input = form.querySelector('input');
  const list = form.querySelector('#i6-hits');
  const count = form.querySelector('#i6-count');
  if (!input || !list || !count) { resetView(); return; }
  function search() {
    const term = input.value.trim().toLowerCase();let total=0;
    list.querySelectorAll('li').forEach(row => {row.hidden = !term || !row.dataset.i6Name.includes(term);if (!row.hidden) total++;});
    list.hidden = total===0;
    count.textContent = !term ? '' : total ? total + (total===1 ? ' ingredient' : ' ingredients') : count.dataset.none;
  }
  input.addEventListener('input',search,{signal});
  form.addEventListener('submit',event => {event.preventDefault();search();},{signal});
  search();resetView();
  }
  initIngredients();
  document.addEventListener('shopify:section:load', initIngredients);
  document.addEventListener('shopify:section:unload', event => { if (event.target.matches('.sap-content-pages[data-br3="ingredients9"]') || event.target.querySelector('.sap-content-pages[data-br3="ingredients9"]')) { cleanup(); setTimeout(initIngredients, 0); } });
})();
